
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zoopedia-pro",
      function () {
        return require("private-next-pages/zoopedia-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zoopedia-pro"])
      });
    }
  